import {
    GET_MISSING_UPC_REQUEST,
    GET_MISSING_UPC_SUCCESS,
    GET_MISSING_UPC_ERROR
} from "./types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

const axios = require("axios");
export const getMissingUpc = (token, statusID) => (dispatch) => {
    console.log({statusID});

    dispatch({ type: GET_MISSING_UPC_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/missingUPC`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            product_status_id: statusID.length > 0 ? statusID.toString() : null,
           
        }
    })
        .then((response) => {
            return dispatch({ type: GET_MISSING_UPC_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_MISSING_UPC_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_MISSING_UPC_ERROR,
                payload: error.response,
            });
        });
};
